import { getSubAccountWalletReport } from "./API";

const GetSubAccountWalletsReport = async (subAccounts, accessToken) => {
    try {
        const { data } = await getSubAccountWalletReport(subAccounts, accessToken);

        const walletData = data?.flatMap(acct => {
            return acct.wallets.map(wallet => {
                return {
                    ...wallet,
                    subAccountName: acct.subAccount,
                    groupName: acct.group,
                    createdAt: wallet.createdAt?.split("T")[0],
                };
            });
        });

        return { success: true, data: walletData };
    } catch (error) {
        return {
            success: false,
            data: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Error: Error getting report data.",
        };
    }
};

export default GetSubAccountWalletsReport;
